var TOP_SEARCH = '[data-component="topSearch"]';
var TOP_SEARCH_INPUT = '[data-element="topSearchInput"]';
var TOP_SEARCH_SUBMIT = '[data-element="topSearchSubmit"]';
var TOP_SEARCH_CLOSE = '[data-element="topSearchClose"]';
var IS_SEARCH_OPENED_CLASS = 'is-search-opened';
var ARIA_EXPANDED = 'aria-expanded';
var topSearch = document.querySelector(TOP_SEARCH);
if (topSearch) {
  var topSearchForm = topSearch.querySelector('form');
  var topSearchInput = topSearch.querySelector(TOP_SEARCH_INPUT);
  var topSearchSubmit = topSearch.querySelector(TOP_SEARCH_SUBMIT);
  var topSearchClose = topSearch.querySelector(TOP_SEARCH_CLOSE);
  var isSearchOpened = false;
  var closeSearch = function closeSearch() {
    document.body.classList.remove(IS_SEARCH_OPENED_CLASS);
    topSearchSubmit.setAttribute(ARIA_EXPANDED, false);
    isSearchOpened = false;
  };
  var openSearch = function openSearch() {
    document.body.classList.add(IS_SEARCH_OPENED_CLASS);
    topSearchInput.focus();
    isSearchOpened = true;
    topSearchSubmit.setAttribute(ARIA_EXPANDED, true);
    document.body.addEventListener('click', function autoClose(event) {
      if (!event.target.closest(TOP_SEARCH)) {
        document.removeEventListener('click', autoClose);
        closeSearch();
      }
    });
  };
  topSearchSubmit.addEventListener('click', function (e) {
    if (isSearchOpened && topSearchInput.value) {
      topSearchForm.submit();
    } else if (isSearchOpened && !topSearchInput.value) {
      closeSearch();
      e.preventDefault();
    } else {
      openSearch();
      e.preventDefault();
    }
  });
  topSearchClose.addEventListener('click', function (e) {
    e.preventDefault();
    closeSearch();
  });
}